import React, { useEffect } from 'react';
import './UpdatePaymentMethodFlex.scss';
import { useQuery } from '@apollo/client';
import { useLocation } from 'react-router-dom';
import { GET_UPDATE_PAYMENT_METHOD_URL_FLEX } from '../../services/ApolloClient';
import { useApp } from '../../contexts';

import { UpdatePaymentMethodFlexData } from '../../types/flex';
import { hasValidStoredToken, navigateToExternalRoute } from '../../utils';
import { buildLoginRedirectPath } from '../../services/ApolloClient/authErrorHandling';

function UpdatePaymentMethodFlex(): React.JSX.Element {
  const { setLoading } = useApp();
  const location = useLocation();
  const hasValidToken = hasValidStoredToken();
  const {
    data: updatePaymentMethodFlexData,
    loading: updatePaymentMethodFlexLoading,
    error: updatePaymentMethodFlexError,
  } = useQuery<UpdatePaymentMethodFlexData>(GET_UPDATE_PAYMENT_METHOD_URL_FLEX, {
    fetchPolicy: 'no-cache',
    skip: !hasValidToken,
    variables: {
      forceUpdate: true,
    },
  });

  useEffect(() => {
    if (!hasValidToken) {
      navigateToExternalRoute(buildLoginRedirectPath(location.pathname, location.search));
    }
  }, [hasValidToken, location.pathname, location.search]);

  useEffect(() => {
    if (updatePaymentMethodFlexData) {
      navigateToExternalRoute(
        updatePaymentMethodFlexData?.getUpdatePaymentMethodUrlFlex?.url || '#',
      );
    }
  }, [updatePaymentMethodFlexData]);

  useEffect(() => {
    setLoading(updatePaymentMethodFlexLoading);
  }, [updatePaymentMethodFlexLoading, setLoading]);

  const getMessage = () => {
    if (
      updatePaymentMethodFlexError?.message === 'Not authenticated' ||
      updatePaymentMethodFlexError?.message === 'No active membership found for user'
    ) {
      return {
        title: 'Payment Method Update Unavailable',
        description: 'You can only update your payment method for active subscriptions.',
      };
    }
    if (updatePaymentMethodFlexError) {
      return {
        title: 'The link has been expired',
        description: '',
      };
    }
    return { title: 'Redirecting...', description: '' };
  };

  return (
    <div className="update-payment-method-unavailable-container">
      <h2 className="title">{getMessage().title}</h2>
      <p className="description">{getMessage().description}</p>
    </div>
  );
}

export default UpdatePaymentMethodFlex;
